import React from 'react'

export default function EmailTempPreview(props) {
    const {data} = props;
  return (
    <>
  <div className=" w-[40%] overflow-y-scroll h-[620px] rounded-lg p-10  shadow-md    bg-white mx-auto mt-10 ">
  <div className=" w-full h-full   ">
  <div dangerouslySetInnerHTML={{ __html: data }} />
 
  </div>
  </div>
    </>
  )
}
